import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AuthModule } from './app/auth.module';

document.addEventListener('DOMContentLoaded', () => {
    platformBrowserDynamic().bootstrapModule(AuthModule)
        .catch(err => console.error(err));
});